import { cn } from '../lib/cn';

const sizes = { xs: 'h-3 w-3', sm: 'h-4 w-4', md: 'h-5 w-5', lg: 'h-8 w-8' } as const;

export interface SpinnerProps {
  size?: keyof typeof sizes;
  className?: string;
  /** Announced to assistive tech. Pass null inside a button that already has text. */
  label?: string | null;
  'aria-hidden'?: boolean | 'true' | 'false';
}

export function Spinner({ size = 'md', className, label = 'Loading', ...rest }: SpinnerProps) {
  return (
    <span
      role={label ? 'status' : undefined}
      className={cn('inline-flex shrink-0 items-center justify-center', className)}
      {...rest}
    >
      <svg
        className={cn('animate-spin', sizes[size])}
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden="true"
      >
        <circle className="opacity-20" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" />
        <path
          className="opacity-90"
          fill="currentColor"
          d="M12 2a10 10 0 0 1 10 10h-3a7 7 0 0 0-7-7V2Z"
        />
      </svg>
      {label && <span className="sr-only">{label}</span>}
    </span>
  );
}
